export default "__VITE_ASSET__BqGF0lfO__"